/**
 * Created by david on 2017/6/14.
 */

export const SiteConfig = {
    'Site_Title': '科研问卷数据采集平台',
    'Site_Name': '科研问卷数据采集平台',
};

export const SystemMenu = [
    // {
    //     "IsEnabled": true,
    //     "Name": "系统首页",
    //     "ComponentName": "index",
    //     "IsSystemMenu": false,
    //     "SubMenu": null,
    //     "URL": "",
    //     "ICON": "zmdi zmdi-home",
    //     "OrderBy": 1,
    //     "permission": []
    // },
    {
        "IsEnabled": true,
        "Name": "项目管理",
        "ComponentName": "questionnaire",
        "IsSystemMenu": false,
        "URL": "",
        "ICON": "zmdi zmdi-view-array",
        "OrderBy": 2,
        "permission": []
    },
    {
        "IsEnabled": true,
        "Name": "自定义表单",
        "ComponentName": "DiyFormIndex",
        "IsSystemMenu": false,
        "URL": "",
        "ICON": "zmdi zmdi-format-list-numbered",
        "OrderBy": 2,
        "permission": []
    },
    {
        "IsEnabled": true,
        "Name": "单位管理",
        "ComponentName": "unit",
        "IsSystemMenu": false,
        "URL": "",
        "ICON": "zmdi zmdi-account",
        "OrderBy": 2,
        "permission": ['administrator']
    },
    // {
    //     "IsEnabled": true,
    //     "Name": "系统设置",
    //     "ComponentName": "",
    //     "IsSystemMenu": false,
    //     "URL": "",
    //     "ICON": "zmdi zmdi-wrench",
    //     "OrderBy": 2,
    //     "permission": [],
    //     "SubMenu": [
    //         {
    //             "IsEnabled": true,
    //             "Name": "我的资料",
    //             "ComponentName": "myprofile",
    //             "IsSystemMenu": false,
    //             "SubMenu": null,
    //             "URL": "",
    //             "ICON": "",
    //             "OrderBy": 1,
    //             "permission": []
    //         }
    //     ]
    // }
]

// 网站地址
export const SiteHost = (/localhost/).test(window.location.host) ? 'http://wenjuan.botcare.cn' : 'http://' + window.location.host;
export const AdminUrl = SiteHost + '/admin';  // 管理后台地址
export const MobileUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:9999' : SiteHost + '/mobile';  // 手机版地址



// WEBPACK FOOTER //
// ./src/config.ts